import { render, staticRenderFns } from "./main.vue?vue&type=template&id=0f2b2766&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2b2766",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f2b2766')) {
      api.createRecord('0f2b2766', component.options)
    } else {
      api.reload('0f2b2766', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=0f2b2766&scoped=true", function () {
      api.rerender('0f2b2766', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/phase2/manager-form/analytics/components/data-serial-code/main.vue"
export default component.exports